export const prepareSelect = ({ data, field }) => {
  if (!data || !data[field]) return [];

  return data[field]
    .sort()
    .map((option) => ({ id: option, value: option }));
};
